import { TabProps } from '@libs-uuif/shared/sw-tab-layout';

export const selectOptions = [
  { id: 'allGroups', label: 'All groups' },
  { id: 'others', label: 'Others' },
];
export const selectIntervalOptions = [
  { id: '24-hourly', label: 'Last 24 Hours' },
  { id: '7-daily', label: 'Last 7 Days' },
  { id: '30-daily', label: 'Last 30 Days' },
];
export const selectFrequencyOptions = [
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
];
export const selectReportPeriodOptions = [
  { id: 'day', label: 'Last 24 Hours' },
  { id: 'week', label: 'Last 7 Days' },
  { id: 'month', label: 'Last 30 Days' },
];
export const selectWeeklyOptions = [
  { id: '1', label: 'Sunday' },
  { id: '2', label: 'Monday' },
  { id: '3', label: 'Tuesday' },
  { id: '4', label: 'Wednesday' },
  { id: '5', label: 'Thursday' },
  { id: '6', label: 'Friday' },
  { id: '7', label: 'Saturday' },
];
export const scheduleWireless = {
  emails: [''],
  frequency: 'Daily',
  hour: 23,
  is_auto: false,
  period: 'week',
  send_email: false,
  week: 3,
};
export const selectMonthlyOptions = [
  { id: '1', label: '1st day' },
  { id: '2', label: '2nd day' },
  { id: '3', label: '3rd day' },
  { id: '4', label: '4th day' },
  { id: '5', label: '5th day' },
  { id: '6', label: '6th day' },
  { id: '7', label: '7th day' },
  { id: '8', label: '8th day' },
  { id: '9', label: '9th day' },
  { id: '10', label: '10th day' },
  { id: '11', label: '11th day' },
  { id: '12', label: '12th day' },
  { id: '14', label: '14th day' },
  { id: '15', label: '15th day' },
  { id: '16', label: '16th day' },
  { id: '17', label: '17th day' },
  { id: '18', label: '18th day' },
  { id: '19', label: '19th day' },
  { id: '20', label: '20th day' },
  { id: '21', label: '21st day' },
  { id: '22', label: '22nd day' },
  { id: '23', label: '23rd day' },
  { id: '24', label: '24th day' },
  { id: '25', label: '25th day' },
  { id: '26', label: '26th day' },
  { id: '27', label: '27th day' },
  { id: '28', label: '28th day' },
  { id: '29', label: '29th day' },
  { id: '30', label: '30th day' },
  { id: '31', label: '31st day' },
  { id: '32', label: 'last day' },
];

export const selectNsmMonthlyOptions = [
  { id: '1', label: '1st day' },
  { id: '2', label: '2nd day' },
  { id: '3', label: '3rd day' },
  { id: '4', label: '4th day' },
  { id: '5', label: '5th day' },
  { id: '6', label: '6th day' },
  { id: '7', label: '7th day' },
  { id: '8', label: '8th day' },
  { id: '9', label: '9th day' },
  { id: '10', label: '10th day' },
  { id: '11', label: '11th day' },
  { id: '12', label: '12th day' },
  { id: '14', label: '14th day' },
  { id: '15', label: '15th day' },
  { id: '16', label: '16th day' },
  { id: '17', label: '17th day' },
  { id: '18', label: '18th day' },
  { id: '19', label: '19th day' },
  { id: '20', label: '20th day' },
  { id: '21', label: '21st day' },
  { id: '22', label: '22nd day' },
  { id: '23', label: '23rd day' },
  { id: '24', label: '24th day' },
  { id: '25', label: '25th day' },
  { id: '26', label: '26th day' },
  { id: '27', label: '27th day' },
  { id: '28', label: '28th day' },
  { id: '31', label: 'last day' },
];
export const selectTimeOptions = [
  { id: '0', label: '05:30 AM - 06:30 AM' },
  { id: '1', label: '06:30 AM - 07:30 AM' },
  { id: '2', label: '07:30 AM - 08:30 AM' },
  { id: '3', label: '08:30 AM - 09:30 AM' },
  { id: '4', label: '09:30 AM - 10:30 AM' },
  { id: '5', label: '10:30 AM - 11:30 AM' },
  { id: '6', label: '11:30 AM - 12:30 PM' },
  { id: '7', label: '12:30 PM - 01:30 PM' },
  { id: '8', label: '01:30 PM - 02:30 PM' },
  { id: '9', label: '02:30 PM - 03:30 PM' },
  { id: '10', label: '03:30 PM - 04:30 PM' },
  { id: '11', label: '04:30 PM - 05:30 PM' },
  { id: '12', label: '05:30 PM - 06:30 PM' },
  { id: '13', label: '06:30 PM - 07:30 PM' },
  { id: '14', label: '07:30 PM - 08:30 PM' },
  { id: '15', label: '08:30 PM - 09:30 PM' },
  { id: '16', label: '09:30 PM - 10:30 PM' },
  { id: '17', label: '10:30 PM - 11:30 PM' },
  { id: '18', label: '11:30 PM - 12:30 AM' },
  { id: '19', label: '12:30 AM - 01:30 AM' },
  { id: '20', label: '01:30 AM - 02:30 AM' },
  { id: '21', label: '02:30 AM - 03:30 AM' },
  { id: '22', label: '03:30 AM - 04:30 AM' },
  { id: '23', label: '04:30 AM - 05:30 AM' },
];
export const selectProductTabs : TabProps[] = [
  { tabId: 'firewallReport', label: 'Firewall' },
  { tabId: 'captureClientReport', label: 'Capture Client' },
  { tabId: 'wirelessReport', label: 'Wireless' },
];
export interface DataSet {
  id: string;
  status: string;
  product_name: string;
  report_type: string;
  delivery_method: string;
  reportData: any[];
  report_name: string;
  requested_at: string;
  generated_at: string;
  Data: any;
}
export const ccScheduledPostData = {
  activitiesSection: 'none',
  applicationsSection: 'none',
  atpSection: 'none',
  day: '0',
  devicesSection: 'none',
  emails: [''],
  enabled: true,
  fileFormat: 'pdf',
  hour: 0,
  includeAtpHistory: false,
  includeAtpList: false,
  includeDeviceHistory: false,
  includeDeviceList: false,
  includeRiskyAppsList: false,
  includeRiskyDevicesList: false,
  includeTenantList: false,
  includeThreatHistory: false,
  includeThreatList: false,
  name: 'Daily Report',
  schedule: 'daily',
  tenantsSection: 'none',
  threatsSection: 'none',
  webProtectionSection: 'none',
};
export const displayDataTooltip = [
  'Get information of Applications',
  'Get information of Users',
  'Get information of Sources',
  'Get information of Destinations',
  'Get information of Source Locations',
  'Get information of Destination Locations',
  'Get information of Web Categories',
  'Get information of Bandwidth Queues',
  'Get information of Botnet',
  'Get information of Blocked',
  'Get information of Threats',
];
export const wirelessDataTooltip = [
  'Get information of Executive Summary',
  'Get information of Inventory',
  'Get information of Recommendations',
  'Get information of Security (Client Security Service Details)',
  'Get information of Statistics',
  'Get information of Topology',
];
export const ccOnDemandPostData = {
  action: 'Download',
  fileFormat: 'pdf',
  emails: [''],
  frequency: 'hourly',
  nbItems: 40,
  name: 'TestSMC',
  sections: [{}],
};
export const archiveConfig = {
  path: 'S3',
};
export const emailConfig = {
  body: '',
  subject: '',
  emailDestination: [''],
};
export const nsmScheduledPostData: any = {
  deliveryConfig: {
    password: '',
    passwordProtected: false,
    zip: false,
    scheduleHour: 0,
  },
  deviceConfig: {
  },
  intervalType: 0,
  lastRunTS: 0,
  moduleUnionId: 4,
  reportConfig: {
    reportModules: [],
  },
  status: 'Unknown',
  statusMessage: '',
  taskConfig: {
    coverTitle: 'Sonicwall Flow Reports',
    fileFormat: 2,
    coverLogoId: -1,
    language: 'en_US',
    taskDesc: '',
  },
  taskName: 'test-0089',
  view: 2,
};
